import React from "react";
import { Grid, Stack, TextField, Typography } from "@mui/material";
import styled from "styled-components";
import { LoadingButton } from "@mui/lab";
import request from "src/utils/request";
import { useAuth } from "src/components/providers/auth-context";
import WizardPicture from "src/components/wizard-picture";
import { ToastContext } from "src/components/providers/toast-provider";

const Title = styled.p`
    margin: 8px;
`;

const DetailsTextField = styled(TextField)`
    max-width: 166px;
`;

const DetailsSection = () => {
    const { setMessage, setSeverity, setIsToastTriggered } = React.useContext(ToastContext);
    const [givenName, setGivenName] = React.useState(" ");
    const [familyName, setFamilyName] = React.useState(" ");
    const [title, setTitle] = React.useState(" ");
    const [website, setWebsite] = React.useState(" ");

    const { user, updateUser } = useAuth();

    const profileData = {
        name: { givenName, familyName },
        jobTitle: title,
        website,
    };

    const handleSubmit = async () => {
        if (givenName === " ") setGivenName(user.name.givenName || " ");
        if (familyName === " ") setFamilyName(user.name.familyName || " ");
        if (title === " ") setTitle(user.jobTitle || " ");
        if (website === " ") setWebsite(user.website || " ");
        try {
            await request("/api/users/me", {
                method: "POST",
                body: JSON.stringify(profileData),
            });
            updateUser();
            setMessage(`You have successfully updated your user data`);
            setSeverity("success");
            setIsToastTriggered(true);
        } catch (e) {
            setMessage(`Could not update user at the moment. Please try again.`);
            setSeverity("error");
            setIsToastTriggered(true);
        }
    };

    return (
        <>
            <Stack direction="row" style={{ width: "100%" }} justifyContent="space-between">
                <Title>Step 2 - Add your personal details</Title>
                <LoadingButton
                    variant="contained"
                    size="small"
                    color="primary"
                    onClick={handleSubmit}
                >
                    Save
                </LoadingButton>
            </Stack>
            <Stack direction="row" alignItems="center" ml={4.5} mt={1}>
                <WizardPicture
                    picture={user.picture}
                    requestUrl="/api/users/me/picture"
                    onSuccess={() => updateUser()}
                />
                <Grid
                    container
                    direction="row"
                    spacing={2}
                    style={{ padding: "26px", width: "100%" }}
                >
                    <Grid item>
                        <DetailsTextField
                            id="outlined-basic"
                            label={
                                <Typography sx={{ fontSize: 12, paddingTop: "3px" }}>
                                    First Name
                                </Typography>
                            }
                            inputProps={{ fontSize: "11px" }}
                            defaultValue={
                                user.name && user.name.givenName ? user.name.givenName : ""
                            }
                            variant="outlined"
                            size="small"
                            onChange={(event) => setGivenName(event.target.value)}
                        />
                    </Grid>
                    <Grid item>
                        <DetailsTextField
                            id="outlined-basic"
                            label={
                                <Typography sx={{ fontSize: 12, paddingTop: "3px" }}>
                                    Last Name
                                </Typography>
                            }
                            defaultValue={
                                user.name && user.name.familyName ? user.name.familyName : ""
                            }
                            variant="outlined"
                            size="small"
                            onChange={(event) => setFamilyName(event.target.value)}
                        />
                    </Grid>
                    <Grid item>
                        <DetailsTextField
                            id="outlined-basic"
                            label={
                                <Typography sx={{ fontSize: 12, paddingTop: "3px" }}>
                                    Title
                                </Typography>
                            }
                            defaultValue={user && user.jobTitle ? user.jobTitle : ""}
                            variant="outlined"
                            size="small"
                            onChange={(event) => setTitle(event.target.value)}
                        />
                    </Grid>
                    <Grid item>
                        <DetailsTextField
                            id="outlined-basic"
                            label={
                                <Typography sx={{ fontSize: 12, paddingTop: "3px" }}>
                                    Website{" "}
                                </Typography>
                            }
                            defaultValue={user && user.website ? user.website : ""}
                            variant="outlined"
                            size="small"
                            onChange={(event) => setWebsite(event.target.value)}
                        />
                    </Grid>
                </Grid>
            </Stack>
        </>
    );
};

export default DetailsSection;
